import type { BeniBreakdown, BeniMetaComparisonSet } from 'lumen/models';

export type CombinedBreakdowns = {
  ownComparisonSetBreakdown: BeniBreakdown | null;
  primaryComparisonSetBreakdown: BeniBreakdown | null;
  secondaryComparisonSetBreakdown: BeniBreakdown | null;
};
export type BreakdownsDict = Record<string, CombinedBreakdowns>;

export function buildBreakdownDict(params: {
  ownComparisonSetBreakdowns: BeniBreakdown[];
  ownComparisonSetMeta: BeniMetaComparisonSet | null;
  primaryComparisonSetBreakdowns: BeniBreakdown[];
  primaryComparisonSetMeta: BeniMetaComparisonSet | null;
  secondaryComparisonSetBreakdowns: BeniBreakdown[];
  secondaryComparisonSetMeta: BeniMetaComparisonSet | null;
}): BreakdownsDict {
  const {
    ownComparisonSetMeta,
    primaryComparisonSetMeta,
    secondaryComparisonSetMeta,
    ownComparisonSetBreakdowns,
    primaryComparisonSetBreakdowns,
    secondaryComparisonSetBreakdowns,
  } = params;

  const dict: BreakdownsDict = {};

  const addBreakdownToLosDictRecordIfComparisonSetExists = (
    comparisonSetMeta: BeniMetaComparisonSet | null,
    comparisonSetBreakdowns: BeniBreakdown[],
    key: keyof CombinedBreakdowns,
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  ) => {
    if (comparisonSetMeta) {
      comparisonSetBreakdowns.forEach((segmentation) => {
        const { label } = segmentation;

        const existingDictEntry = dict[label];
        if (existingDictEntry) {
          existingDictEntry[key] = segmentation;
        } else {
          const combinedBreakdowns: CombinedBreakdowns = {
            ownComparisonSetBreakdown: null,
            primaryComparisonSetBreakdown: null,
            secondaryComparisonSetBreakdown: null,
          };
          combinedBreakdowns[key] = segmentation;

          dict[label] = combinedBreakdowns;
        }
      });
    }
  };

  addBreakdownToLosDictRecordIfComparisonSetExists(
    ownComparisonSetMeta,
    ownComparisonSetBreakdowns,
    'ownComparisonSetBreakdown',
  );

  addBreakdownToLosDictRecordIfComparisonSetExists(
    primaryComparisonSetMeta,
    primaryComparisonSetBreakdowns,
    'primaryComparisonSetBreakdown',
  );

  addBreakdownToLosDictRecordIfComparisonSetExists(
    secondaryComparisonSetMeta,
    secondaryComparisonSetBreakdowns,
    'secondaryComparisonSetBreakdown',
  );

  return dict;
}
